import { Tooltip } from "antd";
import { CiCalendarDate, CiSearch, CiShop, CiUser } from "react-icons/ci";

import "../style.css"


export function ConsultarBio({ handleChange, formData, handleConsultarBio, loadingBiometria }) {
    return (
        <>
            <div className="input-group slide-up" style={{ animationDelay: '0.2s' }}>
                <label>CNPJ da sua empresa</label>
                <input type="text" name="cnpj" value={formData.cnpj} onChange={handleChange} />
                <span className="input-icon"><CiShop /></span>
            </div>

            <div className="row-form">
                <div className="input-group slide-up" style={{ animationDelay: '0.2s' }}>
                    <label>CPF</label>
                    <input type="text" name="cpf" value={formData.cpf} onChange={handleChange} />
                    <span className="input-icon"><CiUser /></span>
                </div>

                <div className="input-group slide-up" style={{ animationDelay: '0.3s' }}>
                    <label>Data Nascimento</label>
                    <input type="text" name="dataNascimento" value={formData.dataNascimento} onChange={handleChange} />
                    <span className="input-icon"><CiCalendarDate /></span>
                </div>

                <div style={{ animationDelay: '0.3s' }}>
                    <Tooltip title={loadingBiometria ? 'Consultando biometria...' : 'Consultar Bio'}>
                        <button
                            type="button"
                            className="btn-search"
                            onClick={handleConsultarBio}
                            disabled={loadingBiometria}
                            style={{
                                cursor: loadingBiometria ? 'not-allowed' : 'pointer',
                                opacity: loadingBiometria ? 0.6 : 1
                            }}
                        >
                            {loadingBiometria ? (
                                <span className="spinner" />
                            ) : (
                                <CiSearch size={24} />
                            )}
                        </button>
                    </Tooltip>
                </div>
            </div>
        </>
    );
}